
import { aplicarMascaraCpf, validarCpf } from '../../../shared/utils/cpf-validator'
import { formatDateBR } from '../../../shared/utils/date-validator'
export default {
  name: "dicom-plus-gestor-saude",
  props: {
    paciente: {
      type: Object,
      default: null
    },
    procedimentoID: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    abrirGSaude() {
      this.mostrarGSaude = true
    },
    salvarDadosPaciente() {
      const payload = {
        nome: this.paciente?.nome,
        comentarios: this.paciente?.comentarios,
        cpf: this.paciente?.cpf,
        dataNascimento: this.paciente?.dataNascimento,
        requisicaoID: this.paciente?.requisicao,
        especialidades: Array.isArray(this.paciente?.requisicoes) ? this.paciente.requisicoes : []
      };

      this.$emit('atualizar-dados-paciente', payload);
    }
  },
  computed: {
    isCpfValido() {
      return validarCpf(this.paciente?.cpf || '');
    },
    cpfMascara() {
      return aplicarMascaraCpf(this.paciente?.cpf || '');
    },
    dataNascimentoMascara() {
      return formatDateBR(this.paciente?.dataNascimento || '')
    },
    hasNoFiles(){
     if (!this.paciente) return false;
      const reqs = this.paciente.requisicoes;
      return !Array.isArray(reqs) || reqs.length === 0;
    },
    hasNoProcedimentosEspecialidade(){
      return this.paciente?.requisicao?.procedimentosEspecialidade;
    }
  }
}
